import React from "react";
import {withNamespaces} from "react-i18next";
import HilightTable from "../../../../components/HilightTable";
import {Button, ButtonGroup, Spinner} from "react-bootstrap";
import {Link} from "react-router-dom";
import {modalActions} from "../../../../actions/modal.actions";
import {roleActions} from "../../../../actions/role.actions";
import {connect} from "react-redux";

const RoleTable = ({ t, list, showModal, hideModal, removeRole }) => {

    const openDeleteModal = (row) => {
        showModal({
            open: true,
            title: t('are-you-sure'),
            message: t('delete-msg') + `<h5> ${row.label} </h5>`,
            confirmLabel: t('delete-btn'),
            confirmIcon: 'fa-trash',
            classNameBtnConfirm: 'btn-danger',
            confirmAction: () => {
                removeRole(row.id);
                hideModal();
            },
            closeModal: closeModal,
        }, 'confirm')
    };

    const closeModal = () => {
        hideModal()
    };

    const columns = [
        {
            Header: '#',
            accessor: 'id',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
        },
        {
            Header: 'label',
            accessor: 'label'
        },
        {
            Header: 'description',
            accessor: 'description',
        },
        {
            Header: 'actions',
            headerClassName: "text-right",
            classNameRow: 'text-right',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            Cell: (props) => {
                const data = props.row.original;
                return (
                    <ButtonGroup>

                        <Link to={`/panel/role/edit/${data.id}`}>
                            <Button
                                className="mx-1"
                                variant={"primary"}
                            >
                                <i className="fas fa-edit" />
                            </Button>
                        </Link>

                        <Button
                            className="mx-1"
                            variant={"danger"}
                            onClick={() => openDeleteModal(data)}
                        >
                            <i className="fas fa-trash" />
                        </Button>
                    </ButtonGroup>
                )
            }
        }
    ];

    const tableResult = (
        list ?
            list.length === 0 ? (
                <div className="text-center p-4">
                    <h4>{t('roles-no-content')}</h4>
                </div>
            ) : (
                <HilightTable
                    columns={columns}
                    data={list}
                />
            ) : (
                <React.Fragment>
                    <Spinner animation={"border"} />
                    <p>Loading ...</p>
                </React.Fragment>
            )
    );

    return (
        <div className="col-md-12 mx-0 my-3 p-0">
            { tableResult }
        </div>
    )
};

const mapDispatchToProps = (dispatch) => ({
    hideModal: () => dispatch(modalActions.hideModal()),
    showModal: (modalProps, modalType) => {
        dispatch(modalActions.showModal({modalProps, modalType}))
    },
    removeRole: (id) => dispatch(roleActions.deleteRole(id)),
});

export default withNamespaces()(connect(null, mapDispatchToProps)(RoleTable));
